var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32555)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#2080A2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.98875 11.4171C8.34469 12.1523 8.32894 13.1608 8.99606 13.8324C9.62663 13.2249 9.62719 12.0926 8.98875 11.4171ZM8.98931 4.55906C7.46775 6.31856 7.52513 8.39869 8.98819 10.1272C10.4777 8.36325 10.4816 6.29381 8.98931 4.55906ZM10.0648 9.63562C11.3304 8.34187 12.8745 8.046 14.625 8.32613C14.0608 9.61987 13.2649 10.6532 11.8586 11.1937C12.1691 10.9502 12.4521 10.7511 12.708 10.5227C13.1355 10.1419 13.4381 9.68063 13.5894 9.12656C13.6372 8.95163 13.5754 8.90212 13.4145 8.87625C12.8256 8.78175 12.2726 8.9055 11.7444 9.14625C10.8557 9.55125 10.1318 10.1751 9.45281 10.8529C9.441 10.8653 9.43594 10.8832 9.41456 10.9221C10.7449 10.9727 11.7579 11.5037 12.3581 12.7305C11.5785 12.9038 10.8652 12.8672 10.2037 12.4419C10.7021 12.5949 11.1994 12.7063 11.745 12.4476C11.6775 12.3351 11.6381 12.2034 11.5481 12.1297C11.3023 11.9289 11.0503 11.7259 10.7719 11.5729C10.3416 11.3377 9.86062 11.2275 9.3285 11.1184C10.0468 12.3767 9.86681 13.5191 8.98875 14.625C8.58037 14.1103 8.29463 13.572 8.21644 12.9364C8.13769 12.2985 8.31713 11.7191 8.62481 11.1645C7.94419 11.0554 6.4755 11.8434 6.24825 12.4509C6.77531 12.7176 7.28944 12.5961 7.81875 12.3992C7.4385 12.7907 6.34219 12.951 5.62725 12.7153C6.22069 11.5059 7.22869 10.9732 8.58881 10.9226C8.48869 10.8214 8.41444 10.7432 8.33681 10.6684C7.77094 10.1227 7.16962 9.62213 6.46312 9.25763C5.88544 8.9595 5.27963 8.77275 4.61419 8.87231C4.53544 8.88412 4.45725 8.90325 4.347 8.92575C4.5495 9.96637 5.247 10.6116 6.10988 11.1555C5.20313 11.0458 3.67312 9.46125 3.375 8.32388C5.12437 8.04038 6.67687 8.35088 7.93687 9.67331C6.89456 7.35188 7.44919 5.29706 8.98875 3.375C10.5159 5.28188 11.0762 7.32206 10.0648 9.63562Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32555"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlo);
export default __webpack_public_path__ + "static/media/flo.2b041c9915e0d4ad4c94d63d1b024514.svg";
export { ForwardRef as ReactComponent };